import {Type} from 'class-transformer';
import {PropertyMappingQuery} from '../../../properties/models/property-mapping.model';
import {BaseListFilterWithSpecs, IdCodeNameQuery} from 'common-shared';
import {FilterMetadata} from "primeng/api";

export class ItemGroupQuery extends IdCodeNameQuery {
  TypeClv: string;
  @Type(() => PropertyMappingQuery)
  ProcedureItemProperties: PropertyMappingQuery[];
  StatusClv: string;

  From: string[];
  To: string[];

  static Columns() {
    return [...IdCodeNameQuery.Columns(), 'TypeClv', 'StatusClv', 'From', 'To'];
  }

  constructor(init?: Partial<ItemGroupQuery>) {
    super();
    return Object.assign(this, init);
  }
}

export class ItemGroupListQuery extends IdCodeNameQuery {
  Children: string[] = [];
  TypeClv: string;
  StatusClv: string;
  Comment: string;
}

export class ItemGroupListFilter extends BaseListFilterWithSpecs {
  HierarchyNode: FilterMetadata[];
  TypeClv: FilterMetadata | FilterMetadata[];
  Children: FilterMetadata | FilterMetadata[];

  constructor(init?: Partial<ItemGroupListFilter>) {
    super();
    Object.assign(this, init);
  }
}
